import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function render({ theme }) {
  const button = document.querySelector(".c-header__button");
  const cta = document.querySelector(".l-join-us__button");
  const els = document.querySelectorAll(".l-join-us__paragraph");
  const toggle = button.querySelector(".c-header__toggle");
  const join = document.querySelector(".l-join-us");

  function toggleButton() {
    theme.switchTheme();
    gsap.to(button, {
      backgroundColor: theme.isLight() ? "black" : "white"
    });
    gsap.to(toggle, {
      backgroundColor: theme.isLight() ? "white" : "black",
    });
  }

  let showContent = gsap.timeline({
    scrollTrigger: {
      end: "bottom",
      onLeaveBack: () => {
        showContent.reverse();
      },
      scroller: ".smooth-scroll",
      start: "top 90%",
      trigger: ".l-join-us__content",
    },
  });
  showContent.to(els, {
    autoAlpha: 1,
    ease: "Circ.easeIn",
    stagger: {
      each: 0.2,
    },
    translateY: 0,
  });

  let tl = gsap.timeline({
    paused: true,
    scrollTrigger: {
      end: "bottom",
      onEnter: () => {
        toggleButton();
      },
      onEnterBack: () => {
        toggleButton();
      },
      onLeave: () => {
        toggleButton();
      },
      onLeaveBack: () => {
        toggleButton();
      },
      scroller: ".smooth-scroll",
      start: "top 40%",
      trigger: join,
    },
  });
}
